import { render, staticRenderFns } from "./view6.vue?vue&type=template&id=043c6860&scoped=true"
import script from "./view6.vue?vue&type=script&lang=js"
export * from "./view6.vue?vue&type=script&lang=js"
import style0 from "./view6.vue?vue&type=style&index=0&id=043c6860&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "043c6860",
  null
  
)

export default component.exports